/**
 * Microsoft Graph API Client
 *
 * Provides a thin wrapper around fetch for making authenticated
 * requests to the Microsoft Graph API. Used by mailApi.js and
 * calendarApi.js for email notifications and calendar polling.
 *
 * NOTE: Graph API integration is currently non-functional — Supabase
 * OAuth does not provide Microsoft Graph tokens. These functions will
 * throw until a replacement email service (e.g. Resend, SendGrid) is
 * configured via Cloudflare Pages Functions.
 */

/**
 * Make an authenticated request to the Microsoft Graph API.
 *
 * @param {string} endpoint — Graph API endpoint path (e.g. '/me')
 * @param {object} options — fetch options (method, body, headers)
 * @returns {Promise<object>} parsed JSON response
 */
export async function graphRequest(endpoint, options = {}) {
  // No Microsoft access token available — Supabase OAuth replaced MSAL.
  throw new Error('Microsoft Graph API is not configured. Email notifications require a replacement email service.');
}
